import createPersistedState from 'vuex-persistedstate'
import Vue from "vue";
import Vuex from "vuex";
import router from "@/router";

Vue.use(Vuex);

const createInitialState = () => ({
  token: '',
  userInfo: null,
  ip: '',
  wallet: {
    account: '',
    balance: ''
  },
  searchHistory: [],
  language: {},
  signWallet: [],
  aiConversation: [],
  aiQuickSelections: []
})

export default new Vuex.Store({
  state: createInitialState(),
  getters: {},
  mutations: {
    // 设置 token
    SET_TOKEN (state, data) {
      state.token = data;
    },
    // 设置用户信息
    SET_USER_INFO (state, data) {
      state.userInfo = data;
    },
    // 设置IP
    SET_IP (state, data) {
      state.ip = data;
    },
    // 设置钱包信息
    SET_WALLET_INFO (state, data) {
      state.wallet.account = data.account;
      state.wallet.balance = data.balance;
    },
    // 删除钱包信息
    DEL_WALLET_INFO (state, data) {
      state.wallet.account = '';
      state.wallet.balance = '';
    },
    // 添加历史搜索记录
    SET_SEARCH_HISTORY (state, data) {
      if (!state.searchHistory.includes(data)) {
        state.searchHistory.unshift(data);
      }
    },
    // 删除历史搜索记录
    DEL_SEARCH_HISTORY (state, data) {
      state.searchHistory = [];
    },
    // 设置语言
    SET_LANGUAGE (state, data) {
      state.language = data;
      localStorage.setItem('language', JSON.stringify(data));
    },
    // 添加签到钱包余额
    SET_SIGN_WALLET (state, data) {
      state.signWallet = data;
    },

    SET_AI_CONVERSATION (state, data) {
      state.aiConversation = data;
    },

    SET_AI_QUICK_SELECTIONS (state, data) {
      state.aiQuickSelections = data;
    },

    // 退出登录
    QUIT (state, data) {
      let language = state.language;
      Object.assign(state, createInitialState());
      state.language = language;
      router.push('/');
    },
  },
  actions: {},
  plugins: [createPersistedState()]
});
